import { render, staticRenderFns } from "./DesignFormDataAuth.vue?vue&type=template&id=21649030&scoped=true&"
import script from "./DesignFormDataAuth.vue?vue&type=script&lang=js&"
export * from "./DesignFormDataAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21649030",
  null
  
)

export default component.exports